<template>
  <div v-if="languages.length" class="spoken-langs">
    <p class="spoken-langs__title">
      <vb-icon class="spoken-langs__icon" :name="'chat'" :color="sass('primary')" :size="16" />
      <span>Lingue parlate:</span>
    </p>
    <span
      class="spoken-langs__text"
      v-for="(lang, lang_index) in languages"
      :key="_uid + 'lang' + lang_index"
    >
      {{ get_languages(lang).label }}
    </span>
  </div>
</template>

<script>
import {get_languages} from "@bookingv3/resources";

export default {
  name: 'spoken-langs',

  components: {
  },

  props: {
    languages: Array
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
    this.get_languages = get_languages
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .spoken-langs {
    margin-top: $grid-gutter-width;

    @include media-breakpoint-up(md){
      display: flex;
      align-items: center;
      margin-top: $grid-gutter-width*2;
    }

    &__icon {
      margin-right: 5px;
    }

    &__title {
      display: flex;
      align-items: center;
      margin-right: $grid-gutter-width/2;
      font-weight: $vb-font-weight-semibold;

      @include media-breakpoint-up(md){
        margin-bottom: 0;
      }
    }

    &__text {
      margin-right: 10px;
      margin-top: 3px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

</style>